var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPluranaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wrapper",
    clipPath: "url(#clip0_44_5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M34 16.9999C34 26.3888 26.3888 34 16.9999 34C7.61115 34 0 26.3888 0 16.9999C0 7.61115 7.61115 0 16.9999 0C26.3888 0 34 7.61115 34 16.9999Z",
    fill: "#FFA0EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M28.9978 16.9989C28.9978 23.6257 23.6257 28.9978 16.9989 28.9978C10.3721 28.9978 5 23.6257 5 16.9989C5 10.3721 10.3721 5 16.9989 5C23.6257 5 28.9978 10.3721 28.9978 16.9989Z",
    fill: "#FF6EE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M24 17C24 20.866 20.866 24 17 24C13.134 24 10 20.866 10 17C10 13.134 13.134 10 17 10C20.866 10 24 13.134 24 17Z",
    fill: "#FF2BD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluranaLogo);
export default __webpack_public_path__ + "static/media/PluranaLogo.555b4787d0e2a058bfe59adea9387642.svg";
export { ForwardRef as ReactComponent };